/*=========================================================================================
  File Name: action.js
  Description: Restaurants State
  ----------------------------------------------------------------------------------------
  Item Name: Fujisushi Web app
  Author: Tan Tran
==========================================================================================*/
import restaurantsService from "../../../services/restaurants/queries.js";
import errorHandling from "../../../commons/ErrorHandling.js";

export default {
  async getRestaurantsAction({ commit }) {
    let errorType = null;
    try {
      await restaurantsService.getRestaurantsByRestaurantOwner().then(data => {
        commit("SET_RESTAURANTS_STATE", data);
      });
    } catch (err) {
      errorType = errorHandling.getErrorType(err);
    } finally {
      return errorType;
    }
  },

  async getCurrentWaitingTimeAction({ commit }, payload) {
    let errorType = null;
    try {
      let restaurantId = payload.restaurantId;
      await restaurantsService
        .getCurrentWaitingTimeByRestaurant(restaurantId)
        .then(data => {
          commit("SET_CURRENT_WAITING_TIME_STATE", data);
        });
    } catch (err) {
      errorType = errorHandling.getErrorType(err);
    } finally {
      return errorType;
    }
  },

  async getCurrentLocalTimeAction({ commit }) {
    let errorType = null;
    try {
      await restaurantsService.getCurrentLocalTime().then(data => {
        commit("SET_CURRENT_LOCAL_TIME_STATE", data);
      });
    } catch (err) {
      errorType = errorHandling.getErrorType(err);
    } finally {
      return errorType;
    }
  }
};
